import { Col, Row } from 'antd'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import JobCandidateList from './Components/JobCandidateList'
import PreviewHeader from './PageHeader'
import {
  ActionButton,
  ContainerWrapper,
  PageWrapper,
  TextWithIcon,
} from './style'

import CloseRoleDrawer from '../../components/UIComponents/CloseRolePopup'
import PreviewPage from '../../components/UIComponents/PreviewScreen'
import ShortlistIcon from '../../components/icons/Shortlist'
import Debounce from '../../utils/Debounce'
import RoleStatus from './RoleStatus'
import RoleCancelledTemplate from 'components/EmailTemplate/RoleCancelledTemplate'
import ReactDOMServer from 'react-dom/server'
import {sendNotificationBulkEmail, sendInAppNotification, sendNotificationBulkEmailWhatsapp } from 'modules/Students/actions'
import { archiveJobRole, unarchiveJobRole } from '../JobRoles/actions'
export default function JobPreviewIndex({
  getPreviewData,
  previewData,
  getJobRolePreview,
  getJobRoleCandidateList,
  getCandidateMetrics,
  CloseRole,
  getPlacementHistoryList,
  getExportFiledData,
  exportCandidate,
  instituteCampusId,
  getStudentPlacedList,
  getPreview,
  getOneRoleExports,
  duplicateRole,
  completeRole,
  getJobRoleCandidateAppliedList
}) {
  const params = useParams()
  let [searchParams, setSearchParams] = useSearchParams()
  const queryFilter = searchParams.get('q')
  const categorayFilter = searchParams.get('selectedCategory')
  const roleId = params.roleId
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState({})
  const navigate = useNavigate()
  const jobRolePreviewData = useSelector(
    state => state?.jobRolesPreview?.getJobRoleData
  )
  const jobRoleCandidateList = useSelector(
    state => state?.jobRolesPreview?.getCandidateListData
  )

  const instituteDetails = useSelector(
    state => state?.auth?.instituteDetails
  )
  const accessLevel = instituteDetails?.instituteSubscription?.accessLevel
  


  const metricsData = useSelector(state => state?.jobRolesPreview?.metricsData)

  const objectRef = useRef()
  const [state, setState] = useState({
    candidateListPageNo: 0,
    candidateListPageLimit: 10,
    candidateStatus: 'ELIGIBLE',
    selectedIndex: 1,
    candidateSearch: '',
    candidateListLoading: false,
  })

  const dispatch = useDispatch()

  // Redux selectors for institute and user information
  const institute = useSelector(state => state.auth.instituteDetails)
  const userData = useSelector(state => state.auth.userData)
  const userRole = useSelector(state => state.auth.userRole)
  
  // Function to get the user role name
  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?.id === id)[0]?.name
    return roleName ?? 'Admin'
  }
  
  // Get the user role name
  const getUserRoleName = () => {
    return getRoleName(
      userData?.pluginlive_id
        ? userData?.admin?.instRoleId
        : userData?.admin_role_id ?? userData?.role_id
    )
  }

  const getHeaderIndex = status => {
    let response = {}
    switch (status) {
      case 'ELIGIBLE':
        response = {
          candidateStatus: 'ELIGIBLE',
          selectedIndex: 1,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
        }))
        return response
      case 'RESTRICTED':
        response = {
          candidateStatus: 'RESTRICTED',
          selectedIndex: 6,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
        }))
        return response

      case 'INELIGIBLE':
        response = {
          candidateStatus: 'INELIGIBLE',
          selectedIndex: 2,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
          candidateStatus: 'INELIGIBLE',
          selectedIndex: 2,
        }))
        return response

      case 'APPLIED':
        response = {
          candidateStatus: 'APPLIED',
          selectedIndex: 3,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
          candidateStatus: 'APPLIED',
          selectedIndex: 3,
        }))
        return response
      case 'MISSED':
        response = {
          candidateStatus: 'MISSED',
          selectedIndex: 4,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
          candidateStatus: 'MISSED',
          selectedIndex: 4,
        }))
        return response
      case 'PLACED':
        response = {
          candidateStatus: 'PLACED',
          selectedIndex: 5,
        }
        setState(prevState => ({
          ...prevState,
          ...response,
          candidateStatus: 'PLACED',
          selectedIndex: 5,
        }))
        return response
      default:
        break
    }
  }

    // useEffect(() => {
    //   const fetchStudentFilterList = async () => {
    //     try {
    //       const response = await getJobRoleCandidateAppliedList(params?.roleId)
    //       setStudentList(response?.data?.data?.candidateData?.result)
    //     } catch (error) {
    //       console.error('Error fetching applied candidate list:', error)
    //     }
    //   }
  
    //   fetchStudentFilterList() // Call the async function
    // }, [])
    
  const onPageChange = page => {
    let pageNo = page - 1
    objectRef.current.scrollIntoView({ behavior: 'smooth' })
    setState(prev => ({
      ...prev,
      candidateListPageNo: pageNo,
      candidateListLoading: true,
    }))
    getJobRoleCandidateList(
      roleId,
      pageNo,
      state.candidateListPageLimit,
      state.candidateStatus,
      state.candidateSearch,
      setIsLoading
    )
    clearLoadingState()
  }

  const clearLoadingState = () => {
    setTimeout(() => {
      setState(prev => ({
        ...prev,
        candidateListLoading: false,
      }))
    }, 500)
  }

  const companyId = jobRolePreviewData?.companyId

  const fetchPreviewData = async id => {
    try {
      const response = await getJobRolePreview(id)
      setData(response?.data?.data)
    } catch (error) {
      console.error('Error fetching preview data:', error)
      throw error // Rethrow the error to be caught by the caller
    }
  }

  useEffect(() => {
    const query = getHeaderIndex(queryFilter?.toUpperCase() ?? '')
    const fetchData = async () => {
      try {
        setIsLoading(true)
        await fetchPreviewData(roleId)
        await getJobRoleCandidateList(
          roleId,
          state.candidateListPageNo,
          state.candidateListPageLimit,
          query ? query?.candidateStatus : state.candidateStatus,
          state.candidateSearch,
          setIsLoading
        )
        await getCandidateMetrics(roleId)
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [])

  const handleHeaderCellClick = (index, data) => {
    setState({
      ...state,
      selectedIndex: index,
      candidateStatus: data,
      candidateListPageNo: 0,
      candidateListLoading: true,
    })
    searchParams.set('q', data)
    navigate({
      pathname: location.pathname,
      search: searchParams?.toString(),
    })
    getJobRoleCandidateList(
      roleId,
      0,
      state.candidateListPageLimit,
      data,
      state.candidateSearch,
      setIsLoading
    )
    clearLoadingState()
  }

  const handleSearch = data => {
    setState(prev => ({
      ...prev,
      candidateSearch: data,
      candidateListLoading: true,
    }))
    fetchCandidateList(data)
  }

  const fetchCandidateList = useCallback(
    Debounce(searchTerm => {
      getJobRoleCandidateList(
        roleId,
        0,
        state.candidateListPageLimit,
        state.candidateStatus,
        searchTerm,
        setIsLoading
      )
      clearLoadingState()
    }, 1000),
    [
      roleId,
      state.candidateListPageNo,
      state.candidateListPageLimit,
      state.candidateStatus,
    ]
  )

  const onHandleClose = async () => {
    try {
      let payload
      if (jobRolePreviewData?.jobRoleInstituteMap?.[0]?.roleStatus === 'ROLE_CLOSED'
        || jobRolePreviewData?.jobRoleInstituteMap?.[0]?.roleStatus === 'COMPLETED') {
        payload = {
          status: 'RE_OPEN',
          isCompanyId: true,
        }
      } else {
        payload = {
          status: 'ROLE_CLOSED',
          isCompanyId: true,
        }
      }

      await CloseRole(companyId, roleId, payload)
      await fetchPreviewData(roleId)
      const response = await getJobRoleCandidateAppliedList(params?.roleId)
      let studentList = response?.data?.data?.candidateData?.result

      // If we have students who applied for this role, send them notifications
      if (studentList && studentList.length > 0 && payload?.status === 'ROLE_CLOSED') {
        // Collect data for email notifications
        const emailPayloads = studentList.map(student => {
          const emailData = {
            companyName: jobRolePreviewData?.company?.companyName,
            jobTitle: jobRolePreviewData?.tittle,
            studentName: `${student.firstName} ${student.lastName}`,
            signatureName: userData?.first_name + ' ' + userData?.last_name,
            signatureRole: getUserRoleName(),
            signatureInstitute: institute?.campusName || 'Institute',
            signatureContact: userData?.phone_number || institute?.contactNumber
          }

          const emailTemplate = ReactDOMServer.renderToString(
            <RoleCancelledTemplate data={emailData} />
          )

          return {
            to: student.primaryEmail,
            subject: `Role Cancelled - ${jobRolePreviewData?.tittle} at ${jobRolePreviewData?.company?.companyName}`,
            htmlBody: emailTemplate
          }
        })

        // Send email notifications
        if (emailPayloads.length > 0) {
          await dispatch(sendNotificationBulkEmail(emailPayloads))
        }

        // Collect all student IDs for in-app notifications
        const studentIds = studentList.map(student => student.id)

        // Create in-app notification for all students
        if (studentIds.length > 0) {
          const inAppObj = {
            notification: {
              students: [{
                ids: studentIds,
                userIds: [],
                roles: ["Student"],
                issuer: "institute",
                createFor: "student",
                inApp: true,
                body: `Job role cancelled: ${jobRolePreviewData?.tittle} at ${jobRolePreviewData?.company?.companyName}`,
                tag: "Role",
                actions: [{
                  name: "View",
                  deep_link: `roles/viewrole/${jobRolePreviewData?.company?.id}/${jobRolePreviewData?.id}`,
                  route: `roles/viewrole/${jobRolePreviewData?.company?.id}/${jobRolePreviewData?.id}`,
                  parameters: {}
                }]
              }]
            }
          }

          await dispatch(sendInAppNotification(inAppObj))
        }

        // Prepare WhatsApp notifications
        const whatsappPayloads = studentList.map(student => {
          // Extract just the last 10 digits of the phone number
          const phoneNumber = student.phoneNumber.replace(/\D/g, '').slice(-10)
          
          return {
            to: phoneNumber,
            templateName: 'tpo_application_close',
            type: 'template',
            components: [
              {
                type: 'BODY',
                parameters: [
                  { type: 'TEXT', text: `${student.firstName} ${student.lastName}` }, // {{1}} - Student name
                  { type: 'TEXT', text: jobRolePreviewData?.company?.companyName },  // {{2}} - Company name
                  { type: 'TEXT', text: jobRolePreviewData?.tittle }                 // {{3}} - Role name
                ]
              }
            ]
          }
        })

        // Send WhatsApp notifications
        if (whatsappPayloads.length > 0) {
          await dispatch(sendNotificationBulkEmailWhatsapp(whatsappPayloads))
        }
      }
    } catch (err) {
      console.error('Error while closing role:', err)
    }
  }

  const handleBack = () => {
    navigate(`/jobRoles`)
  }

  const handleViewEvaluationClick = () => {
    navigate(
      `/jobRoles/ats/${roleId}?stage=all_candidates&jobType=${jobRolePreviewData?.tittle}&publishedBy=${jobRolePreviewData.rolePublishedBy}`
    )
  }

    const onHandleComplete = async() => {
      await completeRole(roleId, instituteCampusId)
      await fetchPreviewData(roleId)
    }

  return (
    <ContainerWrapper>
      <PreviewHeader
        previewData={jobRolePreviewData}
        getExportFiledData={getExportFiledData}
        exportCandidate={exportCandidate}
        instituteCampusId={instituteCampusId}
        handleBack={handleBack}
        handleViewEvaluationClick={handleViewEvaluationClick}
        status={state.candidateStatus}
        isLoading={isLoading}
        setSearchParams={setSearchParams}
        categorayFilter={categorayFilter}
        downlaodData={state?.selectedIndex}
        getOneRoleExports={getOneRoleExports}
        onHandleClose={onHandleClose}
        completeRole={completeRole}
        onHandleComplete={onHandleComplete}
        archiveJobRole={(campusId, jobId) => dispatch(archiveJobRole(campusId, jobId))}
        unarchiveJobRole={(campusId, jobId) => dispatch(unarchiveJobRole(campusId, jobId))}
        fetchJobRoles={() => getJobRolePreview({ roleId })}
        pageNum={0}
        sortBy=""
      />
      <PageWrapper>
        <Row>
          <Col md={12} xs={12}>
            <PreviewPage
              previewData={data}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              duplicateRole={duplicateRole}
              forPreviewPage={true}
              accessLevel={accessLevel}
            />
          </Col>
          <Col md={12} xs={12}>
            <Row style={{ marginBottom: 20 }}>
              <Col md={24} xs={24}>
                <TextWithIcon justify={'end'}>
                  <RoleStatus
                    jobRolePreviewData={jobRolePreviewData}
                    isLoading={isLoading}
                  />
                </TextWithIcon>
              </Col>
            </Row>
            <JobCandidateList
              getPreview={getPreview}
              candidateList={jobRoleCandidateList?.candidateData || {}}
              onPageChange={onPageChange}
              state={state}
              setState={setState}
              objectRef={objectRef}
              metricsData={metricsData}
              handleHeaderCellClick={handleHeaderCellClick}
              handleSearch={handleSearch}
              getPlacementHistoryList={getPlacementHistoryList}
              getStudentPlacedList={getStudentPlacedList}
              jobRolePreviewData={jobRolePreviewData}
              getJobRolePreview={getJobRolePreview}
              isLoadingState={isLoading}
              queryFilter={queryFilter}
              categorayFilter={categorayFilter}
              exportCandidate={exportCandidate}
              getExportFiledData={getExportFiledData}
              params={params}
              instituteCampusId={instituteCampusId}
              status={state.candidateStatus}
              downlaodData={state?.selectedIndex}
            />
          </Col>
        </Row>
      </PageWrapper>
    </ContainerWrapper>
  )
}
